"use client";

import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="hover:!bg-transparent focus:!bg-transparent relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] after:absolute after:bottom-0 after:left-1/2 after:h-[2px] after:w-0 after:bg-accent after:-translate-x-1/2 after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {mobileMenuOpen && <div className="fixed top-0 left-0 w-full h-screen bg-background border-b border-border md:hidden shadow-medium z-50">
          <div className="flex justify-end p-4">
            <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(false)} aria-label="Close menu">
              <X className="size-6" />
            </Button>
          </div>
          <nav className="flex flex-col py-4">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-6 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="encabezado" className={`sticky top-0 z-50 w-full border-b border-transparent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-16 backdrop-blur-md bg-background/80 border-border" : "h-[90px] bg-background"}`}>
      <div className="container mx-auto h-full px-4 flex items-center justify-between">
        <Link to="/HomePage#" className="flex-shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/marea_mezcal_logo.png" alt="Marea Mezcal" className="h-7" />
        </Link>

        <MenuProvider menu_id="33" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        <Button asChild className="btn-primary hover:!bg-primary-hover focus:!bg-primary-hover hidden md:inline-flex">
          <Link to="#reservar">Reservar Mesa</Link>
        </Button>
      </div>
    </header>;
}